import type { MessageDescriptor } from '@atlassian/jira-intl';
import { EPIC_FIELDTYPE } from '../../constants/fields';
import {
	AsanaHierarchyTypes,
	ClickupHierarchyTypes,
	GROUP,
	ITEM,
	LIST,
	MondayHierarchyTypes,
	NESTED_SUBTASK,
	SECTION,
	SUBITEM,
	SUBTASK,
	TASK,
} from '../../constants/hierarchy';
import { ASANA, CLICK_UP, MONDAY, type SupportedThirdParty } from '../../constants/import-type';
import messages from './messages';

export const getHierarchyMappingItems = (thirdParty: SupportedThirdParty): string[] => {
	switch (thirdParty) {
		case ASANA:
			return AsanaHierarchyTypes;
		case MONDAY:
			return MondayHierarchyTypes;
		case CLICK_UP:
			return ClickupHierarchyTypes;
		default:
			return [];
	}
};

export type FormatMessage = (message: MessageDescriptor) => string;

export const getFieldNameForHierarchyItem = (fieldName: string, formatMessage: FormatMessage) => {
	switch (fieldName.toLowerCase()) {
		case SECTION:
			return formatMessage(messages.sectionField);
		case GROUP:
			return formatMessage(messages.groupField);
		case TASK:
			return formatMessage(messages.taskField);
		case SUBTASK:
			return formatMessage(messages.subtaskField);
		case NESTED_SUBTASK:
			return formatMessage(messages.nestedSubtaskField);
		case EPIC_FIELDTYPE:
			return formatMessage(messages.epicField);
		case ITEM:
			return formatMessage(messages.mondayItemField);
		case SUBITEM:
			return formatMessage(messages.mondaySubItemField);
		case LIST:
			return formatMessage(messages.listField);
		default:
			return fieldName;
	}
};
